import { render, staticRenderFns } from "./DiagnosticCamera.vue?vue&type=template&id=25f8999b&scoped=true"
import script from "./DiagnosticCamera.vue?vue&type=script&lang=ts"
export * from "./DiagnosticCamera.vue?vue&type=script&lang=ts"
import style0 from "./DiagnosticCamera.vue?vue&type=style&index=0&id=25f8999b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f8999b",
  null
  
)

export default component.exports